import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/serialNumber/list`;

export const ROUTE: RouteDefinition = `${baseRoute}/serialNumber/list`;

export const URL = (): RouteDefinition => `${baseRoute}/serialNumber/list`;
